import { Flex } from './flex';
import { Modal } from './modal';
import Stepper from './stepper';

export const layout = {
  CustomFlex: Flex,
  Modal,
  Stepper,
};
